import './utils/polyfills';
import { Refine } from '@refinedev/core';
import { Suspense } from 'react';
// import {
//   DevtoolsPanel,
//   DevtoolsProvider,
// } from '@src/components/LazyComponents';
import { LoadingSpinner } from '@src/components/LoadingSpinner';

// import { useNotificationProvider } from '@refinedev/antd';
import '@refinedev/antd/dist/reset.css';

import routerBindings, {
  DocumentTitleHandler,
  UnsavedChangesNotifier,
} from '@refinedev/react-router';
import { dataProvider } from '@src/providers';
import { App as AntdApp, ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router';
import { authProvider } from '@src/providers';
import { RefineThemes } from '@refinedev/antd';
import { AppRoutes, RESOURCES } from '@src/routes';

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner tip="Loading application..." />}>
        <ConfigProvider
          theme={{
            ...RefineThemes.Blue,
          }}
        >
          <AntdApp>
            {/* <Suspense
              fallback={
                <LoadingSpinner size="small" tip="Loading devtools..." />
              }
            > */}
            {/* <DevtoolsProvider> */}
            <Refine
              dataProvider={dataProvider}
              // notificationProvider={useNotificationProvider}
              routerProvider={routerBindings}
              authProvider={authProvider}
              resources={RESOURCES as any}
              options={{
                syncWithLocation: false,
                warnWhenUnsavedChanges: true,
                useNewQueryKeys: true,
                // projectId: '3WJKSy-IzVuhb-Bipc9H',
              }}
            >
              <AppRoutes />
              <UnsavedChangesNotifier />
              <DocumentTitleHandler />
            </Refine>
            {/* <Suspense
              fallback={
                <LoadingSpinner
                  size="small"
                  tip="Loading devtools panel..."
                />
              }
            >
              <DevtoolsPanel />
            </Suspense> */}
            {/* </DevtoolsProvider> */}
            {/* </Suspense> */}
          </AntdApp>
        </ConfigProvider>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
